import ButtonApi from '../../../../components/ButtonApi';
import Icons from '../../../../components/icons/Icons';
import ToolTip from '../../../../components/toolTip/Tooltip';
import { useEvent } from '../EventProvider';
import { useMint } from './MintNftProvider';
import { useEffect, useState } from 'react';

const SetUsername = () => {
  const [{ isDisabled, suffix, username, setUsername, saveUsername, mintFee, feeToken }] = useMint();
  const [{ campaign }] = useEvent();
  const [referralCode, setReferralCode] = useState('');
  const [isReferralCodeEditable, setIsReferralCodeEditable] = useState(true);

  const hasDynamicFee = campaign?.mintFeeConfig?.dynamicPriceOnUsername;
  const hasFee = hasDynamicFee || campaign?.mintFeeConfig?.amount;

  // Check for referral code in localStorage on component mount
  useEffect(() => {
    const storedRefCode = localStorage.getItem('refCode');
    if (storedRefCode) {
      setReferralCode(storedRefCode);
      setIsReferralCodeEditable(false); // Make it uneditable if it came from URL
    }
  }, []);

  const handleReferralCodeChange = (e) => {
    if (isReferralCodeEditable) {
      const value = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
      setReferralCode(value);
      // Save to localStorage when manually entered
      if (value) {
        localStorage.setItem('refCode', value);
      } else {
        localStorage.removeItem('refCode');
      }
    }
  };

  return (
    <>
      <h2>The Naming Ritual</h2>
      <p>To begin the path, you need a name for your Identity Relic, a name that you own, unique to you.</p>
      <div className='nftname_wrapper'>
        <div className='nftname_container'>
          <input placeholder='Enter username' onChange={setUsername} value={username} />
          <div className='nftname_suffix'>{suffix}</div>
        </div>
        {hasDynamicFee && (
          <ToolTip
            className='dynamic-fee-tooltip'
            contentClassName={'username_tooltip_content'}
            tipContent={
              <>
                <h4>DYNAMIC FEE</h4>
                <p>
                  The fee dynamically adjusts based on the length of your username, ranging from {hasDynamicFee?.minFee} XION for the longest 16-character name to{' '}
                  {hasDynamicFee?.maxFee} XION for a 1-character ultra-rare name, with longer names costing less and shorter rarer names costing more.
                </p>
              </>
            }
            showOnClick={false}
          >
            <div className='username_info_wrapper'>
              <Icons icon={'info'} />
              <h4>DYNAMIC USERNAME CLAIM FEE </h4>
            </div>
          </ToolTip>
        )}
        
        {/* Referral Code Section */}
        <div className='referral_code_wrapper' style={{ display: 'flex', justifyContent: 'center' }}>
          {!isReferralCodeEditable ? (
            // Show only text when code comes from link
            <div className='referral_code_from_link' style={{ alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
              <p className='referral_code_info'>
                Referral code: <strong>{referralCode}</strong> <span className='from_link_text'>(from link)</span>
              </p>
            </div>
          ) : (
            // Show input field when manually entering
            <div className='referral_code_container'>
              <input 
                placeholder='Enter referral code (optional)' 
                onChange={handleReferralCodeChange} 
                value={referralCode} 
                disabled={!isReferralCodeEditable}
                className={!isReferralCodeEditable ? 'prefilled' : ''}
              />
            </div>
          )}
        </div>

        <ButtonApi className='primary' onClick={() => saveUsername(referralCode)} disabled={isDisabled}>
          Set Name
        </ButtonApi>
      </div>
    </>
  );
};

export default SetUsername;
